import { ShadowWrap } from './styles'

import type { ShadowInterface } from './interface'

const Shadow = ({ children }: ShadowInterface) => (
  <ShadowWrap className="shadow-atom">{children}</ShadowWrap>
)

export default Shadow
